import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Upsell } from '@core/models';
import { API_LIST } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpsellService {
  constructor(private httpClient: HttpClient) {}

  checkUpsell(cartId: string): Observable<Upsell> {
    return this.httpClient.get<Upsell>(API_LIST.checkUpsell(cartId));
  }
}
